// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversa',
  working: 'A trabalhar nisso…',
  stopped: 'Interrompido. Nada foi alterado.',
  step_stopped: 'Parado',
  not_sent: 'Não enviado',
  failed: {
    text: 'Algo correu mal do nosso lado, por isso nada foi alterado. Tente novamente dentro de momentos.',
    retry: 'Tentar novamente',
  },
  question: {
    type_answer: 'Ou escreva a sua resposta abaixo.',
  },
  unavailable: {
    title: {
      amigo: 'O Amigo não está disponível neste momento.',
      assistant: 'O assistente não está disponível neste momento.',
    },
    text: 'Nada foi alterado e o resto do painel funciona normalmente. Tente novamente dentro de alguns minutos.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Hoje',
  when: {
    today: 'Hoje, {{time}}',
    yesterday: 'Ontem, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Nova conversa para {{restaurant}}. As conversas de {{previous}} estão em Conversas quando voltar a ele.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Conversa de {{name}} (FoodAmigos)',
      owner: 'Conversa de {{name}} (proprietário)',
      staff: 'Conversa de {{name}} (equipa)',
      partner: 'Conversa de {{name}} (parceiro)',
      other: 'Conversa de {{name}}',
      unnamed: 'Conversa de outra pessoa',
    },
    text: 'Conversa de {{name}}. Pode lê-la, mas não responder nem aprovar os seus cartões.',
    text_unnamed: 'Conversa de outra pessoa. Pode lê-la, mas não responder nem aprovar os seus cartões.',
    new_chat: 'Nova conversa',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Esta conversa terminou. Inicie uma nova conversa para continuar.',
    new_chat: 'Nova conversa',
    moved_line: 'Nova conversa, porque a anterior tinha terminado',
  },
  composer: {
    label: 'Mensagem',
    placeholder: 'Faça uma pergunta ou descreva uma alteração',
    placeholder_answer: 'Escreva a sua resposta',
    hint: 'Enter para enviar · Shift+Enter para nova linha',
  },
  table: {
    show_all: 'Mostrar todas as {{count}} linhas',
    show_fewer: 'Mostrar menos',
  },
  steps: {
    areas: 'A verificar em que posso ajudar aqui',
    area_describe: 'A analisar {{area}}',
    read: 'A ler os seus dados',
    propose: 'A preparar a alteração',
    change_set_get: 'A verificar a alteração',
    gap_record: 'A registar isto para a nossa equipa',
    research: 'A pesquisar como isto funciona',
    screen_find: 'A procurar a página certa',
    file_read: 'A ler o seu ficheiro',
    shop_check: 'A verificar a sua loja',
    area_describe_other: 'A analisar esta área',
    other: 'A verificar uma coisa',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Não foi possível ler o menu',
      hours: 'Não foi possível ler o horário de funcionamento',
      order_settings: 'Não foi possível ler as definições de encomenda',
      my_info: 'Não foi possível ler os seus dados',
      marketing: 'Não foi possível ler o seu marketing',
      gift_cards: 'Não foi possível ler os cartões-presente',
      reports: 'Não foi possível ler os seus números',
      other: 'Não foi possível ler os seus dados',
    },
    propose: {
      menu: 'Não foi possível preparar a alteração do menu',
      hours: 'Não foi possível preparar a alteração do horário de funcionamento',
      order_settings: 'Não foi possível preparar a alteração das definições de encomenda',
      my_info: 'Não foi possível preparar a alteração dos seus dados',
      marketing: 'Não foi possível preparar a alteração de marketing',
      gift_cards: 'Não foi possível preparar a alteração dos cartões-presente',
      other: 'Não foi possível preparar a alteração',
    },
    change_set_get: { other: 'Não foi possível verificar a alteração' },
    research: { other: 'Não foi possível consultar como isto funciona' },
    screen_find: { other: 'Não foi possível encontrar a página' },
    file_read: { other: 'Não foi possível ler o seu ficheiro' },
    shop_check: { other: 'Não foi possível abrir a sua loja' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'o menu',
    hours: 'o horário de funcionamento',
    order_settings: 'as definições de encomenda',
    my_info: 'as informações do seu restaurante',
    marketing: 'marketing',
    reports: 'os relatórios',
  },
};
